import React, { useEffect, useState } from 'react';
import { apiService } from '../services/api';
import './BookingModal.css';

const emptyForm = {
  name: '',
  email: '',
  phone: '',
  message: '',
  preferred_date: '',
  preferred_time: ''
};

const BookingModal = ({ show, onClose, title = 'Book an Appointment', serviceName = '', planName = '', type = 'appointment_request' }) => {
  const [form, setForm] = useState(emptyForm);
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);
  const isPlanEnquiry = Boolean(planName) || type === 'plan_enquiry';

  useEffect(() => {
    if (show) {
      setForm(emptyForm);
      setStatus('');
      setLoading(false);
    }
  }, [show, planName, title]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus('');

    try {
      const payload = {
        type: isPlanEnquiry ? 'plan_enquiry' : type,
        name: form.name,
        email: form.email,
        phone: form.phone,
        message: form.message,
        service: serviceName,
        plan_name: planName,
        preferred_date: form.preferred_date || undefined,
        preferred_time: form.preferred_time || undefined
      };

      const res = isPlanEnquiry
        ? await apiService.submitPlanEnquiry(payload)
        : await apiService.submitBooking(payload);

      if (res.data?.success) {
        setStatus('success');
        setForm(emptyForm);
        setTimeout(() => {
          onClose();
          setStatus('');
        }, 2500);
      } else {
        setStatus('error');
      }
    } catch (err) {
      console.error('Booking submit error:', err);
      setStatus('error');
    } finally {
      setLoading(false);
    }
  };

  if (!show) return null;

  return (
    <div className="booking-modal-overlay" onClick={onClose} role="presentation">
      <div className="booking-modal" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
        <button type="button" className="booking-modal-close" onClick={onClose} aria-label="Close">
          ×
        </button>
        <h3>{isPlanEnquiry ? 'Plan Enquiry' : title}</h3>
        <p className="booking-modal-context">
          {planName
            ? planName
            : serviceName
              ? serviceName
              : 'Tell us how to reach you and we will get back to you.'}
        </p>

        {status === 'success' && (
          <div className="booking-modal-note booking-modal-note--success">
            Thank you. Your enquiry has been sent. We will reply shortly.
          </div>
        )}
        {status === 'error' && (
          <div className="booking-modal-note booking-modal-note--error">
            Something went wrong. Please call +91-8130885755 or try again.
          </div>
        )}

        {status !== 'success' && (
          <form className="booking-form" onSubmit={handleSubmit}>
            <label>
              Name
              <input name="name" value={form.name} onChange={handleChange} placeholder="Your name" required />
            </label>
            <label>
              Email
              <input type="email" name="email" value={form.email} onChange={handleChange} placeholder="Your email" required />
            </label>
            <label>
              Phone
              <input type="tel" name="phone" value={form.phone} onChange={handleChange} placeholder="Your phone" required={isPlanEnquiry} />
            </label>
            {!isPlanEnquiry && (
              <div className="booking-form-row">
                <label>
                  Preferred date
                  <input type="date" name="preferred_date" value={form.preferred_date} onChange={handleChange} />
                </label>
                <label>
                  Preferred time
                  <input type="time" name="preferred_time" value={form.preferred_time} onChange={handleChange} />
                </label>
              </div>
            )}
            <label>
              Message
              <textarea name="message" rows={4} value={form.message} onChange={handleChange} placeholder="What would you like to know?" required={isPlanEnquiry} />
            </label>
            <button type="submit" className="btn btn-primary booking-form-submit" disabled={loading}>
              {loading ? 'Sending...' : isPlanEnquiry ? 'Send Enquiry' : 'Submit Request'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default BookingModal;
